export enum RouteEnum {
  FusionCompany = 'syncCompany',
  SyncWithOwner = 'syncWithOwner',
  Fusion = 'syncUser',
  SyncWithoutOwner = 'SyncWithoutOwner',
  FusionFromOwner = 'syncUserFromCompany',
  CompanyUsers = 'companyUsers',
  Login = 'login',
  NotFound = 'notFound',
  AzureCheck = 'azureCheck',
  AuthCallback = 'authCallback',
  Dashboard = 'dashboard',
  Create = 'create',
}

export const PublicRouteList = [
  RouteEnum.Login,
  RouteEnum.AzureCheck,
  RouteEnum.AuthCallback,
  RouteEnum.NotFound,
]
